import { action, runInAction, observable } from 'mobx';
// import cloneDeep from 'lodash/cloneDeep';
import { ErrorInterface } from 'modules/core/api/globalApi';
import promoReferenceController from './controller';
import {
  PromoInterface,
  PromoListRequestInterface,
  PromoCreateRequest,
  PromoUpdateRequest,
  ProjectPromoInterface,
  ProjectPromoCreateRequest,
  ServicePromoInterface,
  ServicePromoCreateRequest,
  PartnerPromoInterface,
  PartnerPromoCreateRequest,
} from '../api/promoReferenceApi';
// import { getTimeInMinutes } from './schedulerFunctions';

export interface PromoReferenceStore {
  promos: PromoInterface[],
  getPromosRequest: PromoListRequestInterface,
  currentPromo: PromoInterface,

  projectPromos: ProjectPromoInterface[],
  projectPromosByPromoId: string,
  currentProjectPromo: ProjectPromoInterface,

  servicePromos: ServicePromoInterface[],
  servicePromosByPromoId: string,
  currentsServicePromo: ServicePromoInterface,

  partnerPromos: PartnerPromoInterface[],
  partnerPromosByPromoId: string,
  currentPartnerPromo: PartnerPromoInterface,

  promosForSelector: PromoInterface[],
  getPromosForSelectorRequest: PromoListRequestInterface,

  error: ErrorInterface,
}

const initialValues: PromoReferenceStore = {
  promos: [],
  getPromosRequest: null,
  currentPromo: null,

  projectPromos: [],
  projectPromosByPromoId: undefined,
  currentProjectPromo: null,

  servicePromos: [],
  servicePromosByPromoId: undefined,
  currentsServicePromo: null,

  partnerPromos: [],
  partnerPromosByPromoId: undefined,
  currentPartnerPromo: null,

  promosForSelector: [],
  getPromosForSelectorRequest: null,

  error: null,
};

export const promoReferenceStore = observable(initialValues);

export const promoReferenceActions = {

  async getPromoList(request :PromoListRequestInterface) {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.getPromosRequest = request;
    });
    const response = await promoReferenceController.getPromoList(request);
    if (response.errorData) {
      promoReferenceStore.getPromosRequest = null;
    }
    promoReferenceActions.handleError(response);
    runInAction(() => {
      promoReferenceStore.promos = response.data?.items;
    //  schedulerReferenceStore.loading = false;
    });
  },

  handleError: action((response, id:string = null) => {
    if (response.errorData) {
      const { errorData } = response;
      promoReferenceStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
        id,
      };
      // schedulerReferenceStore.loading = false;
      throw errorData;
    }
  }),

  handleErrorWithoutThrow: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      // schedulerReferenceStore.loading = false;
      promoReferenceStore.error = errorData;
    }
  }),

  createPromo: async (request: PromoCreateRequest): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.createPromo(request);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.promos.push(response.data);
      }
    });
  },

  updatePromo: async (request: PromoUpdateRequest): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.updatePromo(request);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.promos = promoReferenceStore.promos
          .map((v) => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    });
  },

  deletePromo: async (id: string): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.deletePromo(id);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.promos
          .find((v) => v.id === id).deletedDate = 'deleted';
      }
    });
  },

  restorePromo: async (id: string): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.restorePromo(id);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.promos = promoReferenceStore.promos
          .map((v) => (v.id === id
            ? { ...v, postDeletedDate: null }
            : { ...v }));
      }
    });
  },

  async clearPromos() {
    try {
      runInAction(() => {
        promoReferenceStore.promos = [];
        promoReferenceStore.getPromosRequest = null;
      });
    } catch (err) {
      this.handleError(err);
    }
  },

  setCurrentPromo: async (data: PromoInterface): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentPromo = data;
    });
  },

  clearCurrentPromo: async (): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentPromo = null;
    });
  },

  clearError: action(() => {
    promoReferenceStore.error = null;
  }),

  // блок управления проектами в акциях
  async getProjectPromoList(promoId: string) {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.projectPromosByPromoId = promoId;
    });
    const response = await promoReferenceController.getProjectPromoList(promoId);
    if (response.errorData) {
      promoReferenceStore.projectPromosByPromoId = undefined;
    }
    promoReferenceActions.handleError(response);
    runInAction(() => {
      promoReferenceStore.projectPromos = response.data?.items;
    //  schedulerReferenceStore.loading = false;
    });
  },

  createProjectPromo: async (request: ProjectPromoCreateRequest): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.createProjectPromo(request);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.projectPromos.push(response.data);
      }
    });
  },

  deleteProjectPromo: async (id: string): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.deleteProjectPromo(id);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.projectPromos = [...promoReferenceStore.projectPromos.filter((v) => v.id !== id)];
      }
    });
  },

  setCurrentProjectPromo: async (data: ProjectPromoInterface): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentProjectPromo = data;
    });
  },

  clearCurrentProjectPromo: async (): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentProjectPromo = null;
    });
  },
  // конец блока управления проектами в акциях

  // блок управления сервисами в акциях
  async getServicePromoList(promoId: string) {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.servicePromosByPromoId = promoId;
    });
    const response = await promoReferenceController.getServicePromoList(promoId);
    if (response.errorData) {
      promoReferenceStore.servicePromosByPromoId = undefined;
    }
    promoReferenceActions.handleError(response);
    runInAction(() => {
      promoReferenceStore.servicePromos = response.data?.items;
    //  schedulerReferenceStore.loading = false;
    });
  },

  createServicePromo: async (request: ServicePromoCreateRequest): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.createServicePromo(request);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.servicePromos.push(response.data);
      }
    });
  },

  deleteServicePromo: async (id: string): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.deleteServicePromo(id);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.servicePromos = [...promoReferenceStore.servicePromos.filter((v) => v.id !== id)];
      }
    });
  },

  setCurrentServicePromo: async (data: ServicePromoInterface): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentsServicePromo = data;
    });
  },

  clearCurrentServicePromo: async (): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentsServicePromo = null;
    });
  },
  // конец блок управления сервисами в акциях

  // блок управления партнёрами в акциях
  async getPartnerPromoList(promoId: string) {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.partnerPromosByPromoId = promoId;
    });
    const response = await promoReferenceController.getPartnerPromoList(promoId);
    if (response.errorData) {
      promoReferenceStore.partnerPromosByPromoId = undefined;
    }
    promoReferenceActions.handleError(response);
    runInAction(() => {
      promoReferenceStore.partnerPromos = response.data?.items;
      //  schedulerReferenceStore.loading = false;
    });
  },

  createPartnerPromo: async (request: PartnerPromoCreateRequest): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.createPartnerPromo(request);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.partnerPromos.push(response.data);
      }
    });
  },

  deletePartnerPromo: async (id: string): Promise<void> => {
    promoReferenceActions.clearError();
    const response = await promoReferenceController.deletePartnerPromo(id);
    promoReferenceActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoReferenceStore.partnerPromos = [...promoReferenceStore.partnerPromos.filter((v) => v.id !== id)];
      }
    });
  },

  setCurrentPartnerPromo: async (data: PartnerPromoInterface): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentPartnerPromo = data;
    });
  },

  clearCurrentPartnerPromo: async (): Promise<void> => {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.currentPartnerPromo = null;
    });
  },
  // конен блока управления партнёрами в акциях

  async getPromoListForSelector(request :PromoListRequestInterface) {
    promoReferenceActions.clearError();
    runInAction(() => {
      promoReferenceStore.getPromosForSelectorRequest = request;
    });
    const response = await promoReferenceController.getPromoList(request);
    if (response.errorData) {
      promoReferenceStore.getPromosForSelectorRequest = null;
      promoReferenceStore.promosForSelector = null;
    }
    promoReferenceActions.handleError(response);
    runInAction(() => {
      promoReferenceStore.promosForSelector = response.data?.items;
    });
  },

};
